var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSoko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 60",
    role: "img",
    "aria-label": "SoKo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SoKo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 48,
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: 52,
    fontWeight: 500,
    fill: "#0B3A4A",
    letterSpacing: 3
  }, "SOKO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSoko);
export default __webpack_public_path__ + "static/media/logo_soko.c4842d31988fcd667085e0f195013de9.svg";
export { ForwardRef as ReactComponent };